import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Maximize } from "lucide-react";
 * // Use <Maximize /> instead
 */
export const FullscreenOnIcon = createSVGWrapper(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M3 5C3 3.89543 3.89543 3 5 3H10V5H5V10H3V5ZM19 5H14V3H19C20.1046 3 21 3.89543 21 5V10H19V5ZM5 14V19H10V21H5C3.89543 21 3 20.1046 3 19V14H5ZM19 19V14H21V19C21 20.1046 20.1046 21 19 21H14V19H19Z"
    fill="currentColor"
  />
);
